import { Component, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
	children: ReactNode
	fallback?: ReactNode
}

interface State {
	hasError: boolean
	error: Error | null
}

function DefaultFallback() {
	const { t } = useTranslation()
	return (
		<div className="generate-error" style={{ margin: '16px 0' }}>
			<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
				<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
			</svg>
			{t('generate.error.boundary')}
		</div>
	)
}

export default class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props)
		this.state = { hasError: false, error: null }
	}

	static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error }
	}

	componentDidCatch(error: Error, info: { componentStack: string }): void {
		console.error('[ErrorBoundary]', error, info.componentStack)
	}

	render(): ReactNode {
		if (this.state.hasError) {
			return this.props.fallback ?? <DefaultFallback />
		}
		return this.props.children
	}
}
